import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/use-toast';
import { ChatState } from './types';

export const createReadStatusOperations = (set: any, get: () => ChatState) => ({
  markAsRead: async () => {
    const storeId = get().currentStoreId;
    if (!storeId) return;
    
    try {
      const { error } = await supabase.functions.invoke('update-read-status', {
        body: { storeId }
      });
      
      if (error) {
        console.error('Error marking messages as read:', error);
        toast({
          title: "Error",
          description: "Failed to mark messages as read",
          variant: "destructive"
        });
      } else {
        set({ unreadCount: 0 });
      }
    } catch (error) {
      console.error('Error in markAsRead:', error);
    }
  },
  
  getUnreadCount: async (storeId: string) => {
    try {
      const { data, error } = await supabase.functions.invoke('get-unread-messages', {
        body: { storeId }
      });
      
      if (error) {
        console.error('Error getting unread count:', error);
      } else if (data) {
        set({ unreadCount: data.count });
      }
    } catch (error) {
      console.error('Error in getUnreadCount:', error);
    }
  },
});
